import React, { useState } from 'react'
import classNames from 'classnames'
import { CheckboxInputProps } from './CheckboxInput.d'
import { FieldInputOption } from '@toasttab/shared/src/graphql/FormFieldCategory'

const CheckboxInput = ({
  id,
  labels,
  label,
  name,
  stacked,
  onChange,
  checked,
  variation,
  error,
  darkMode = false
}: CheckboxInputProps) => {
  const defaultChecked = checked
  const [isChecked, setIsChecked] = useState(defaultChecked)

  const labelClassNames = classNames({
    'text-secondary': variation === 'default',
    'flex flex-row items-center brand2': variation === 'default' && stacked,
    'inline-flex flex-row items-start brand2':
      variation === 'default' && !stacked,
    block: variation === 'web' && stacked,
    'inline-block': variation === 'web' && !stacked
  })

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked((prev) => !prev)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  const renderCheckboxField = (optionLabel: string, i: number) => {
    return (
      <label className={labelClassNames} key={i}>
        {variation === 'default' && !isChecked && (
          <svg
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='flex-shrink-0 w-[28px] md:w-[18px] mt-1 mr-1'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16 0C17 0 17.9 0.8 18 1.9V2V16C18 17 17.2 17.9 16.1 18H16H2C1 18 0.1 17.2 0 16.1V16V2C0 1 0.8 0.1 1.9 0H2H16ZM16 1.5H2C1.8 1.5 1.6 1.7 1.5 1.9V2V16C1.5 16.2 1.7 16.4 1.9 16.5H2H16C16.2 16.5 16.4 16.3 16.5 16.1V16V2C16.5 1.8 16.3 1.6 16 1.5Z'
              fill='#666666'
              className='stroke'
            />
          </svg>
        )}
        {variation === 'default' && isChecked && (
          <svg
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className='flex-shrink-0 w-[28px] md:w-[18px] mt-1 mr-1'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2ZM6.7 11.8l7.7-7.5c.4-.4 1-.4 1.3 0 .4.4.4.9 0 1.3l-8.4 8.2c-.4.4-1 .4-1.3 0l-3.7-3.6c-.4-.4-.4-.9 0-1.3s1-.4 1.3 0l3.1 2.9Z'
              fill={!darkMode ? `#2B4FB9` : `#FFFFFF`}
              className='stroke'
            />
          </svg>
        )}
        <input
          type='checkbox'
          name={name}
          id={id}
          className='mr-1 appearance-none'
          onChange={handleInputChange}
          checked={isChecked}
          value={isChecked ? 'true' : 'false'}
        />
        {optionLabel}
      </label>
    )
  }

  const errorClassNames = classNames({
    'absolute top-full w-max flex flex-row font-sansPro items-center text-error text-xs font-semibold left-0 leading-4 xl:-mb-[6px] before:content-[""] before:bg-icon-warning-outline before:bg-center before:bg-contain before:bg-no-repeat before:w-4 before:h-4 before:block before:mr-2':
      variation === 'default'
  })

  return (
    <>
      {labels?.map((option: FieldInputOption, i: number) => {
        if (option.optionLabel === '' || option.optionLabel === 'hidden') {
          return null
        }
        return renderCheckboxField(option.optionLabel, i)
      })}
      {label && renderCheckboxField(label, 0)}
      {error && (
        <div role='alert' className={errorClassNames}>
          {error}
        </div>
      )}
    </>
  )
}

export default CheckboxInput
